<template>
  <div style="width: 100%">
    <v-select
      :value="rawData()"
      :multiple="false"
      @input="onUpdate($event)"
      :items="item.items"
      v-if="item.as === 'select' && !selectIsOther"
      class="form-line-input"
    >
    </v-select>
    <div v-else-if="item.as === 'staff'" class="d-flex align-center">
      <v-btn class="mr-2" icon @click="onUpdate('')" v-if="canClear"
        ><v-icon>clear</v-icon></v-btn
      >
      <v-btn class="mr-2" icon @click="onUpdate(trigram)" v-if="canSetSelf">
        <v-icon>account_circle</v-icon>
      </v-btn>
      <v-autocomplete
        :value="rawData()"
        :items="staff"
        @input="onUpdate($event)"
        :readonly="!isAdminOrSuperAdmin"
      >
      </v-autocomplete>
    </div>
    <div v-else-if="item.as === 'geocomplete'">
      <vuetify-google-autocomplete
        prepend-icon="map"
        class="form-line-input"
        @placechanged="getAddressData"
        :append-icon="validAddress ? 'check' : null"
        :value="rawData()"
        :id="item.name"
        :types="item.addressTypes || null"
        persistent-hint
      />
    </div>
    <v-menu
      ref="datemenu"
      :close-on-content-click="item.as === 'date'"
      :nudge-right="40"
      lazy
      transition="scale-transition"
      offset-y
      full-width
      min-width="290px"
      v-else-if="item.as === 'date' || item.as === 'month-year'"
      v-model="showMenu"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :value="asDate()"
          prepend-icon="event"
          @input="onUpdate($event, 'date')"
          :read-only="showMenu"
          class="form-line-input"
          v-on="on"
        >
          <template v-slot:append v-if="item.clearable">
            <v-icon @click="onClear">clear</v-icon>
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        :value="data()"
        @input="onUpdate($event, 'date')"
        no-title
        scrollable
        :type="item.as === 'date' ? 'date' : 'month'"
      >
        <v-spacer></v-spacer>
      </v-date-picker>
    </v-menu>
    <v-combobox
      v-else-if="item.autocompleteUrl != null"
      :items="autocomplete"
      @update:search-input="onUpdate($event)"
      @input="onUpdate($event, null, { autocomplete: true })"
      :hide-no-data="true"
      :return-masked-value="true"
      class="hide-arrow"
      :value="data()"
    ></v-combobox>
    <v-text-field
      :value="data()"
      :type="item.as === 'money' || item.as === 'number' ? 'number' : 'text'"
      :hint="item.hint"
      @input="onUpdate($event)"
      class="form-line-input"
      :data-vv-name="item.name"
      v-validate="validator"
      :error-messages="errors.collect(item.name)"
      :suffix="item.suffix"
      @click:append="selectIsOther = false"
      :items="autocomplete != null ? autocomplete : undefined"
      :append-icon="
        item.as === 'money' ? 'euro' : selectIsOther ? 'undo' : null
      "
      v-else
    />
  </div>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import { fetchHil2 } from "@/utils";

export default {
  props: ["item", "value", "addressIsValidAtBeginning"],
  data() {
    return {
      fceUp: 0,
      showMenu: false,
      validAddress: false,
      selectIsOther: false,
      autocomplete: []
    };
  },
  mounted() {
    if (this.item.addressIsValidAtBeginning) {
      this.validAddress = this.item.addressIsValidAtBeginning();
    }
    if (this.item.as === "select" && !this.hasSelectAllowedValue) {
      this.selectIsOther = true;
    }
    if (this.item.autocompleteUrl != null) {
      this.fetchAutocomplete();
    }
  },
  methods: {
    async fetchAutocomplete() {
      this.autocomplete = (
        await fetchHil2("get", this.item.autocompleteUrl)
      ).map(({ name }) => name);
    },
    async onUpdate(value, validation = null, props = {}) {
      if (this.$validator.fields.items.some(f => f.name === this.item.name)) {
        const isValid = await this.$validator.validate(this.item.name, value);
        if (!isValid) {
          this.$emit("invalid");
          return;
        }
      }

      let v = value;
      if (this.item.as === "select" && value === "__") {
        v = "";
        this.selectIsOther = true;
      }
      if (validation === "date") {
        if (v === "") {
          v = null;
        }
        if (this.item.as === "date") {
          if (/^[0123]\d\/[01]\d\/\d\d\d\d$/.test(v)) {
            v = moment(v, "DD/MM/YYYY").toISOString();
          } else if (/^\d\d\d\d-\d\d-\d\d$/.test(v)) {
            v = moment(v, "YYYY-MM-DD").toISOString();
          } else {
            return;
          }
        } else if (this.item.as === "month-year") {
          const mode = this.item.mode || "start";
          const adjust =
            mode === "start"
              ? d => d.startOf("month").toISOString()
              : d => d.endOf("month").toISOString();
          if (/^[01]\d\/\d\d\d\d$/.test(v)) {
            v = adjust(moment(v, "MM/YYYY"));
          } else if (/^\d\d\d\d-\d\d$/.test(v)) {
            v = adjust(moment(v, "YYYY-MM"));
          } else {
            return;
          }
        }
      }
      if (this.value) {
        _.set(this.value, this.item.name, v);
      }
      if (this.item.update) {
        this.item.update(v);
      }
      await this.$emit("input", this.value ? this.value : v);
      if (this.item.cascade) {
        await this.item.cascade.call(this, this.value ? this.value : v, props);
      }
      this.fceUp += 1;
      this.$forceUpdate();
    },
    onClear() {
      this.$emit("clear");
    },
    getAddressData(data, format) {
      if (!data) {
        this.validAddress = false;
        if (this.item.onAddressChanged) {
          this.item.onAddressChanged.call(this, null);
        }
        this.onUpdate("");
        return;
      }

      if (this.item.onAddressChanged) {
        this.item.onAddressChanged.call(this, data, format);
      }
      this.onUpdate(format.formatted_address);
      this.validAddress = true;
    },
    asDate: function() {
      let v = this.rawData();
      if (v == null) {
        return v;
      }
      if (this.item.as === "date") {
        return moment(String(v)).format("DD/MM/YYYY");
      } else {
        return moment(String(v)).format("MM/YYYY");
      }
    },
    rawData() {
      if (this.item.value) {
        return this.item.value();
      } else if (this.value) {
        let [a, b] = this.item.name.split(".");
        if (b != null) {
          return this.value[a] ? this.value[a][b] : "";
        } else {
          return this.value[a];
        }
      } else {
        return null;
      }
    },
    data: function() {
      let v = this.rawData();
      if (this.item.as === "select" && !this.selectIsOther) {
        const [res] = this.item.items.filter(({ value }) => v === value);
        return res ? res.text : "-";
      }
      if (this.item.as === "staff") {
        const [res] = this.staff.filter(({ value }) => v === value);
        return res ? res.text : "-";
      }
      if (this.item.as === "month-year") {
        const mode = this.item.mode || "start";
        // Compensate for timezone
        v =
          mode === "start"
            ? moment(v)
                .startOf("month")
                .add(1, "day")
                .toISOString()
            : moment(v)
                .endOf("month")
                .subtract(1, "day")
                .toISOString();
      }
      return v;
    }
  },
  computed: {
    validator() {
      if (this.item.validation) {
        const type = typeof this.item.validation;
        if (type === "string" || type === "object") {
          return this.item.validation;
        }
      }
      return {};
    },
    hasSelectAllowedValue() {
      if (this.rawData() === undefined) {
        return true;
      }
      return (
        this.item.items
          .map(({ value }) => value)
          .filter(v => v !== "__")
          .indexOf(this.rawData()) !== -1
      );
    },

    ...mapState("autocompletes", {
      allStaff: state => state.staff
    }),

    ...mapState("user", ["trigram"]),
    ...mapGetters("user", ["isAdminOrSuperAdmin"]),

    staff() {
      return this.allStaff
        .filter(
          ({ trigram, isDeactivated }) => trigram != null && !isDeactivated
        )
        .map(({ firstName, lastName, trigram, email }) => ({
          text: `${trigram} - ${
            lastName
              ? firstName
                ? `${firstName} ${lastName}`
                : lastName
              : email
          }`,
          value: trigram
        }));
    },

    canClear() {
      const raw = this.rawData();
      const isEmpty = raw == null || raw === "";

      if (isEmpty) {
        return false;
      }

      if (this.item.permission === "no-button") {
        return false;
      }

      return this.item.permission === "self"
        ? this.isAdminOrSuperAdmin || raw === this.trigram
        : true;
    },

    canSetSelf() {
      const raw = this.rawData();
      const isSelf = raw === this.trigram;
      const isEmpty = raw == null || raw === "";

      if (isSelf) {
        return false;
      }

      if (this.item.permission === "no-button") {
        return false;
      }

      return this.item.permission === "self"
        ? this.isAdminOrSuperAdmin || isEmpty
        : true;
    }
  }
};
</script>
